import { GET_AGENT_BRAND } from '../../endpoints';
import { IAgentBrand } from '../../types/agent';
import makeAuthenticatedRequest from '../base-api';

const getAgentBrandApi = async (
  agentId: string,
  brandId: string
): Promise<{
  success: boolean;
  data?: IAgentBrand[];
  message?: string;
}> => {
  try {
    const response = await makeAuthenticatedRequest(
      GET_AGENT_BRAND(agentId, brandId),
      {
        method: 'GET',
      }
    );

    const result = await response.json();

    if (!result.success) {
      throw new Error(result.message);
    }

    return result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export { getAgentBrandApi };
